export default __webpack_public_path__ + "static/media/available_dark.bff025ba.png";